var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-card", { staticStyle: { height: "100%" } }, [
    _c("div", { staticClass: "d-chart-card" }, [
      _c(
        "div",
        {
          staticClass: "overflowX-hidden mx-8",
          staticStyle: { height: "100%", "overflow-y": "hidden" },
        },
        [
          _c(
            "v-row",
            { staticClass: "mt-4", attrs: { "no-gutters": "" } },
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-1 mb-1 primary--text",
                      attrs: { "x-small": "" },
                    },
                    [_vm._v("fas fa-broadcast-tower ")]
                  ),
                  _c("p", { staticClass: "text-center mb-0 primary--text" }, [
                    _vm._v("Spreads"),
                  ]),
                  _c("p", { staticClass: "text-center mb-0 mx-1" }, [
                    _vm._v("-"),
                  ]),
                  _c("p", { staticClass: "text-center mb-0" }, [
                    _vm._v(_vm._s(_vm.cardInfo.name)),
                  ]),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-menu",
                {
                  attrs: {
                    "offset-y": "",
                    "max-height": "350",
                    "close-on-click": "",
                    "close-on-content-click": false,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    color: "primary",
                                    small: "",
                                    text: "",
                                    dark: "",
                                  },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_vm._v(" Symbols ")]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.symbolsMenu,
                    callback: function ($$v) {
                      _vm.symbolsMenu = $$v
                    },
                    expression: "symbolsMenu",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "v-list",
                        {
                          staticClass: "overflowY-auto",
                          attrs: { "max-height": "250", dense: "" },
                        },
                        [
                          _vm._l(_vm.allSymbols, function (item, index) {
                            return _c(
                              "v-list-item",
                              {
                                key: index,
                                on: {
                                  click: function ($event) {
                                    item.selected = !item.selected
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-title",
                                  { class: { "primary--text": item.selected } },
                                  [_vm._v(_vm._s(item.symbol))]
                                ),
                              ],
                              1
                            )
                          }),
                          !_vm.allSymbols.length
                            ? _c(
                                "v-list-item",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v(" No symbols available ")]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        {
                          style: _vm.$vuetify.theme.dark
                            ? "background: #1e1e1e"
                            : "background: #fff",
                          on: { click: _vm.updateTableColumns },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              style: _vm.$vuetify.theme.dark
                                ? "border-top: 1px solid rgb(255, 255, 255, 0.3)"
                                : "border-top: 1px solid rgb(0, 0, 0, 0.3)",
                              attrs: { text: "", width: "100%", small: "" },
                            },
                            [_vm._v("Save")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "v-menu",
                {
                  attrs: {
                    "offset-y": "",
                    "max-height": "350",
                    "close-on-click": "",
                    "close-on-content-click": false,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    color: "primary",
                                    small: "",
                                    text: "",
                                    dark: "",
                                  },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_vm._v(" Watchers ")]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.watchersMenu,
                    callback: function ($$v) {
                      _vm.watchersMenu = $$v
                    },
                    expression: "watchersMenu",
                  },
                },
                [
                  _c(
                    "v-list",
                    {
                      staticClass: "overflowY-auto",
                      attrs: { "max-height": "250", dense: "" },
                    },
                    [
                      _vm._l(_vm.watchersMenuItems, function (item, index) {
                        return _c(
                          "v-list-item",
                          {
                            key: index,
                            on: {
                              click: function ($event) {
                                item.selected = !item.selected
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              {
                                class: {
                                  "primary--text": item.selected,
                                  "grey--text": item.appStatus !== "RUN",
                                },
                              },
                              [_vm._v(_vm._s(item.name))]
                            ),
                          ],
                          1
                        )
                      }),
                      !_vm.watchersMenuItems.length
                        ? _c(
                            "v-list-item",
                            { staticStyle: { "font-size": "12px" } },
                            [_vm._v(" No watchers available ")]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    {
                      style: _vm.$vuetify.theme.dark
                        ? "background: #1e1e1e"
                        : "background: #fff",
                      on: { click: _vm.updateTableRows },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          style: _vm.$vuetify.theme.dark
                            ? "border-top: 1px solid rgb(255, 255, 255, 0.3)"
                            : "border-top: 1px solid rgb(0, 0, 0, 0.3)",
                          attrs: { text: "", width: "100%", small: "" },
                        },
                        [_vm._v("Save")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", small: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("delete", _vm.cardInfo)
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "flex-grow-1 text-center",
                      staticStyle: { "font-size": "12px !important" },
                    },
                    [_vm._v(" fa-solid fa-trash ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.loadingData
            ? _c(
                "v-row",
                {
                  staticStyle: { height: "100%" },
                  attrs: {
                    justify: "center",
                    align: "center",
                    "fill-height": "",
                  },
                },
                [
                  _c("v-progress-circular", {
                    staticClass: "mb-4",
                    attrs: { size: 30, color: "primary", indeterminate: "" },
                  }),
                ],
                1
              )
            : _vm.headers.length < 2 && _vm.tableData.length
            ? _c(
                "v-row",
                {
                  staticStyle: { height: "calc(100% - 30px)" },
                  attrs: {
                    justify: "center",
                    align: "center",
                    "fill-height": "",
                  },
                },
                [_vm._v(" No Symbols Selected ")]
              )
            : _vm.tableData.length
            ? _c(
                "div",
                { staticStyle: { "overflow-x": "auto" } },
                [
                  _c("v-data-table", {
                    key: _vm.rowRenderKey,
                    attrs: {
                      dense: "",
                      "items-per-page": -1,
                      headers: _vm.headers,
                      items: _vm.tableData,
                      "hide-default-footer": "",
                      height: _vm.tableHeight * 84 - 84,
                      "fixed-header": "",
                      "mobile-breakpoint": 0,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "tr",
                              _vm._l(_vm.headers, function (header, i) {
                                return _c(
                                  "td",
                                  {
                                    key: header.value,
                                    staticClass: "live_table_cell mid-item",
                                    class: {
                                      "primary--text":
                                        item[header.value].status ===
                                          _vm.PW_PRICE_STATUSES.INCREASE &&
                                        _vm.$vuetify.theme.dark,
                                      "secondary--text":
                                        item[header.value].status ===
                                          _vm.PW_PRICE_STATUSES.INCREASE &&
                                        !_vm.$vuetify.theme.dark,
                                      "red--text text--lighten-3":
                                        item[header.value].status ===
                                          _vm.PW_PRICE_STATUSES.DECREASE &&
                                        _vm.$vuetify.theme.dark,
                                      "red--text":
                                        item[header.value].status ===
                                          _vm.PW_PRICE_STATUSES.DECREASE &&
                                        !_vm.$vuetify.theme.dark,
                                    },
                                  },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: {
                                          disabled:
                                            item.appStatus === "RUN" ||
                                            header.value !== "broker",
                                          "content-class": "tooltipClass",
                                          bottom: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "p",
                                                    _vm._g(
                                                      {
                                                        staticClass: "mb-0",
                                                        class: {
                                                          "grey--text":
                                                            item.appStatus !==
                                                            "RUN",
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            i == 0
                                                              ? item.broker
                                                              : item[
                                                                  header.value
                                                                ].value
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c(
                                          "span",
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "mr-1",
                                                staticStyle: {
                                                  "font-size": "14px",
                                                  "margin-bottom": "4px",
                                                },
                                                attrs: { color: "red" },
                                              },
                                              [
                                                _vm._v(
                                                  "fas fa-exclamation-triangle"
                                                ),
                                              ]
                                            ),
                                            _vm._v("Application not running "),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ]
                        },
                      },
                      {
                        key: "no-data",
                        fn: function () {
                          return [
                            _c(
                              "v-row",
                              {
                                staticClass: "mx-0 fullSize",
                                attrs: { justify: "center" },
                              },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { "align-self": "center" } },
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { justify: "center" } },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "font-size": "0.875rem",
                                            },
                                          },
                                          [_vm._v("No data available")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              )
            : !_vm.tableData.length
            ? _c(
                "v-row",
                {
                  staticStyle: { height: "calc(100% - 30px)" },
                  attrs: {
                    justify: "center",
                    align: "center",
                    "fill-height": "",
                  },
                },
                [
                  _c("p", { staticClass: "grey--text text-center" }, [
                    _vm._v("No data available"),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }